'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _get4 = require('lodash/get');

var _get5 = _interopRequireDefault(_get4);

var _momentTimezone = require('moment-timezone');

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _Api2 = require('./Api');

var _Api3 = _interopRequireDefault(_Api2);

var _User = require('../user/User');

var _User2 = _interopRequireDefault(_User);

var _extractJSON = require('../helper/extractJSON');

var _extractJSON2 = _interopRequireDefault(_extractJSON);

var _uuid = require('../helper/uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = (0, _extractJSON2.default)(_jsCookie2.default.get('config'));

var _ref = _User2.default.platformConfig() || config && config.user || {},
    platformHost = _ref.platformHost,
    platformPort = _ref.platformPort,
    platformProtocol = _ref.platformProtocol;

var ENV = {
  platformHost: platformHost || process.env.PLATFORM_HOST || 'localhost',
  platformPort: platformPort || process.env.PLATFORM_PORT || 8081,
  platformProtocol: platformProtocol || process.env.PLATFORM_PROTOCOL || 'http'
};

var defaultOptions = {
  auth: {
    adAccountId: null,
    authToken: null,
    credentialId: null,
    impersonate: null
  },
  domain: ENV.platformHost,
  path: '/',
  port: ENV.platformPort,
  protocol: ENV.platformProtocol

  /* eslint-disable sort-keys */
};var endpoints = {
  adaccounts: {
    many: '/adaccounts',
    one: '/adaccounts/{record}',
    params: {
      record: 'id'
    },
    queryParams: ['credentialId', 'fromCreds', 'fromShares'],
    enabled: {
      many: '/adaccounts/{parent}/enabled/{record}',
      params: {
        parent: 'id',
        record: 'credentialId'
      }
    },
    shares: {
      one: '/adaccounts/{record}/shares',
      params: {
        record: 'id'
      }
    }
  },
  dashboards: {
    many: '/dashboards/'
  },
  entities: {
    tokens: {
      many: '/entities/tokens',
      body: {
        entityIDs: 'entityIDs'
      },
      queryParams: ['valid']
    },
    has_valid_token: {
      many: '/entities/has_valid_token',
      body: {
        entityIDs: 'entityIDs'
      }
    }
  },
  impersonate: {
    body: {
      user: 'user'
    },
    one: '/impersonate'
  },
  identity: {
    auth: {
      validate: {
        one: '/identity/auth/validate'
      }
    },
    register: {
      invite: {
        body: {
          email: 'email'
        },
        one: '/identity/register/invite'
      }
    },
    password: {
      forgot: {
        body: {
          email: 'email'
        },
        one: '/identity/password/forgot'
      }
    },
    temporary: {
      invite: {
        body: {
          email: 'email',
          firstName: 'firstName',
          lastName: 'lastName',
          body: 'body',
          type: 'type'
        },
        one: '/identity/temporary_user/invite'
      }
    }
  },
  rendering: {
    jobs: {
      one: '/rendering/jobs',
      body: {
        filename: 'filename',
        urls: 'urls',
        src_key: 'src_key',
        options: 'options',
        screenshotOptions: 'screenshotOptions'
      },
      job: {
        one: '/rendering/jobs/{record}',
        params: {
          record: 'id'
        },
        queryParams: ['src_key']
      }
    },
    presentation_jobs_post: {
      one: '/rendering/presentation_jobs'
    },
    presentation_jobs_get: {
      one: '/rendering/presentation_jobs/{record}',
      params: {
        record: 'id'
      }
    },
    preview: {
      one: '/rendering/preview/{record}',
      params: { record: 'key' },
      queryParams: ['src_key']
    }
  },
  reports: {
    campaigns: {
      many: '/reports/campaigns',
      queryParams: ['campaign_ids', 'publisher', 'ad_account_ids']
    },
    adAccounts: {
      many: '/reports/adaccounts',
      queryParams: ['ad_account_ids', 'publisher']
    }
  },
  businessRules: {
    search: {
      many: '/rule-engine/rules',
      one: '/rule-engine/rules/{record}',
      params: {
        record: 'id'
      },
      queryParams: ['searchName', 'limit', 'page', 'searchGroupId', 'enable']
    },
    updateDroolDirectly: {
      one: '/rule-engine/rules/{record}/drl',
      params: {
        record: 'id'
      },
      body: {
        drl_content: 'drl_content'
      }
    },
    createNewRule: {
      one: '/rule-engine/rules',
      queryParams: ['group_id'],
      body: {
        name: 'name',
        description: 'description'
      }
    },
    updateRule: {
      one: '/rule-engine/rules/{record}',
      params: {
        record: 'id'
      },
      body: {
        name: 'name',
        description: 'description',
        status: 'status',
        group_ids: 'group_ids'
      }
    },
    deleteRule: {
      one: '/rule-engine/rules/{record}',
      params: {
        record: 'ruleId'
      }
    },
    group: {
      many: '/rule-engine/groups',
      queryParams: ['modelName'],
      create: {
        one: '/rule-engine/groups',
        queryParams: ['model'],
        body: {
          group_name: 'group_name',
          packages: 'packages'
        }
      }
    },
    action: {
      many: '/rule-engine/actions'
    },
    version: {
      many: '/rule-engine/rules/{parent}/versions',
      one: '/rule-engine/versions/{record}',
      params: {
        record: 'id',
        parent: 'ruleId'
      },
      updateRuleVersionContent: {
        many: '/rule-engine/rules/{parent}/versions/{record}',
        params: {
          parent: 'rule_id',
          record: 'version_id'
        },
        body: {}
      },
      forkNewRuleVersion: {
        many: '/rule-engine/rules/{parent}/versions/{record}/fork',
        params: {
          parent: 'rule_id',
          record: 'version_id'
        }
      },
      approveVersion: {
        many: '/rule-engine/rules/{parent}/versions/{record}/approve',
        params: {
          parent: 'rule_id',
          record: 'version_id'
        }
      },
      deleteVersion: {
        many: '/rule-engine/rules/{parent}/versions/{record}',
        params: {
          parent: 'ruleId',
          record: 'versionId'
        }
      },
      createNewRuleVersion: {
        one: '/rule-engine/rules/{record}/versions',
        params: {
          record: 'rule_id'
        }
      }
    },
    model: {
      many: '/rule-engine/models',
      one: '/rule-engine/models/{record}',
      params: {
        record: 'name'
      },
      rule: {
        one: '/rule-engine/models/rule/{record}',
        params: {
          record: 'rule_id'
        }
      }
    },
    supportedFunction: {
      many: '/rule-engine/rules/supported_function'
    },
    suggestion: {
      many: '/rule-engine/rules/suggestions'
    },
    formulaValidate: {
      many: '/rule-engine/rules/formula_validate',
      body: {}
    }
  },
  notifications: {
    subscribers: {
      create: {
        one: '/notification-job/v2/notification/subscribers'
      },
      credentials: {
        one: '/notification-job/v2/notification/subscribers/{record}/credentials',
        params: {
          record: 'subscriberId'
        }
      }
    }
  }
  /* eslint-enable sort-keys */

};
var PlatformApi = function (_Api) {
  (0, _inherits3.default)(PlatformApi, _Api);

  function PlatformApi(options) {
    (0, _classCallCheck3.default)(this, PlatformApi);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PlatformApi.__proto__ || (0, _getPrototypeOf2.default)(PlatformApi)).call(this, (0, _assign2.default)({}, defaultOptions, options)));

    _this._endpoints = (0, _assign2.default)({}, _this._endpoints, endpoints);
    return _this;
  }

  (0, _createClass3.default)(PlatformApi, [{
    key: 'buildHeaders',
    value: function buildHeaders() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var headers = (0, _get3.default)(PlatformApi.prototype.__proto__ || (0, _getPrototypeOf2.default)(PlatformApi.prototype), 'buildHeaders', this).call(this, state);

      var auth = this._options.auth;

      var authToken = (0, _get5.default)(state, 'authToken') || _User2.default.authToken();
      var companyId = _User2.default.parentCompanyId();

      var impersonating = _User2.default.impersonating();
      var impersonate = impersonating && impersonating.identityID || auth && auth.impersonate;

      headers['X-Unified-Timezone'] = _momentTimezone2.default.tz.guess();

      if (!this._options.debug) headers['X-Unified-RequestID'] = (0, _uuid2.default)(); // e.g. 62ea3584-a0ec-4ae2-bada-d8cae839f9bb
      if (authToken) headers['X-Unified-Auth-Token'] = authToken;
      if (companyId) headers['X-Unified-CompanyID'] = companyId;
      if (impersonate) headers['X-Unified-Impersonate'] = impersonate;

      if (this._options.useFakeResponse) headers['X-Unified-Fake-Response'] = true;

      return headers;
    }
  }, {
    key: 'buildQueryParams',
    value: function buildQueryParams(name) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var params = (0, _get3.default)(PlatformApi.prototype.__proto__ || (0, _getPrototypeOf2.default)(PlatformApi.prototype), 'buildQueryParams', this).call(this, name, state);

      var auth = this._options.auth;

      if (auth.adAccountId) params.push('ad_account_id=' + auth.adAccountId);
      if (auth.credentialId) params.push('credentialId=' + auth.credentialId);

      return params;
    }
  }]);
  return PlatformApi;
}(_Api3.default);

exports.default = PlatformApi;
//# sourceMappingURL=PlatformApi.js.map